import { getApiUrl, API_URL } from '@/utils/api';
import { stringifyObject } from '@/utils/millesimaUtils';
import { AjaxError } from './Ajax.service';
import { RootState } from '@/redux/create-store';

export class LoggerService {
  static logUrl = getApiUrl(API_URL.ADMIN, '/logEvent');

  public async sendLogV2(
    { cartId, message, storeId, url, userId, data }:
    { cartId: string, message: any, storeId: string, url: string, userId?: string, data?: any }
  ) {
    url = stringifyObject(url);
    data = stringifyObject(data);
    message = stringifyObject(message);

    console.debug(
      `sendLog store:${storeId}, user:${userId}, cart:${cartId}, url:${url}, msg:${message}, data:${data}`
    );

    fetch(LoggerService.logUrl, {
      method: 'POST',
      headers: {
        'content-Type': 'application/json'
      },
      body: JSON.stringify({
        cartId, message, storeId, url, userId, data
      })
    }).catch((error) => {
      console.error('sendAjaxErrorLog error:', error);
    });
  }

  static sendLog(
    cartId: string, message: any, storeId: string, url: string, userId?: string,
    data?: any, logUrlCustom = LoggerService.logUrl, getState?: () => RootState
  ) {
    if (getState?.().root.isTestEnv) {
      return;
    }
    url = stringifyObject(url);
    data = stringifyObject(data);
    message = stringifyObject(message);

    console.debug(
      `sendLog store:${storeId}, user:${userId}, cart:${cartId}, url:${url}, msg:${message}, data:${data}`
    );

    fetch(logUrlCustom, {
      method: 'POST',
      headers: {
        'content-Type': 'application/json'
      },
      body: JSON.stringify({
        cartId, message, storeId, url, userId, data
      })
    }).catch((error) => {
      console.error('sendAjaxErrorLog error:', error);
    });
  }

  static sendAjaxErrorLog(error: AjaxError | string, status: any): void {
    const logMsg = `New AjaxError : ${JSON.stringify(error)} -- ${JSON.stringify(status)}`;
    console.error('sendAjaxErrorLog:', logMsg);
    // don't send log to admin back on each error (to many call)
    // this have to be replace with log file
  }
}
